import { InsightData } from 'schemas/action/InsightDataSchema'
import { Filter } from 'schemas/FilterSchema'

import { SearchFilterComposingStrategy } from './searchFilterComposingStrategy'

const composeDetailSearchFilter = (filter: Filter, insights: InsightData[]) => ({
  ...filter,
  includedProductHierarchy: insights
    .map((i) => {
      const splitedSearchName = i.searchName?.split('+') || []
      return splitedSearchName?.map((z) => [z])
    })
    .flat()
})

const generateIncludedProductHierarchyStrategy = (): SearchFilterComposingStrategy => ({
  composeDetailSearchFilter
})

export default generateIncludedProductHierarchyStrategy
